/**
 * @file: 删除操作存快照
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../../cubeTree/index';
import UUID from '../../../utils/uuid';
import Utils from '../../../utils/util';
import Storage from '../../../storage/index';
import Config from '../../../config/index';
import { createRemoveItem } from './createItem';

function removeStackIn(params: StackInParams): Promise<void> {
    let actionId: string = new UUID().id;
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let dataList: HistoryItem[] = createItemList(params, `action-${actionId}`, paperId);

    return Storage.addGroup('history', dataList);
}

function createItemList(params: StackInParams, actionId: string, paperId: number): HistoryItem[] {
    let result: HistoryItem[] = [];

    params.data = CubeTree.sortByCubeIndex(params.data);
    params.data.forEach((removeCubeId: CubeId): void => {
        let item: RemoveHistoryItem = createRemoveItem(removeCubeId);

        result.push({
            actionId,
            paperId,
            type: 'remove',
            data: [item],
            extendParams: {}
        });
    });

    return result;
}

export {
    removeStackIn
};
